import React, { useEffect, useContext } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { GlobalContext } from 'commons';
import * as additionalInformationSelectors from 'state/selectors/additionalInformationSelectors';
import * as additionalInformationActions from 'state/actions/additionalInformationActions';
import _ from "lodash";

const AdditionalInformationSection = ({ getCustomFields, customFields, setCustomFieldEditable }) => {
  const { account: { id: contactId } } = useContext(GlobalContext);

  useEffect(() => {
    getCustomFields(contactId);
  }, []);


  useEffect(() => {
    if (_.some(customFields, ['editable', true])) {
      if (typeof setCustomFieldEditable === 'function') {
        setCustomFieldEditable(true);
      }
    }
  }, [customFields]);

  return (
    <div className="additional-info-section">
      <div className="additional-info">
        {
          customFields.map(customField => (
            customField.savedValues !== null &&
              <div key={customField.attrId} className="row">
                <span className="col-12 label notranslate" id={customField.name}>
                  {customField.name}:
                </span>
                <span className="col-12 notranslate" eb-test={customField.name}>
                  {customField.savedValues.join(', ')}
                </span>
              </div>
          ))
        }
      </div>
    </div>
  );
};

AdditionalInformationSection.propTypes = {
  getCustomFields: PropTypes.func.isRequired,
  customFields: PropTypes.arrayOf(PropTypes.object),
  setCustomFieldEditable: PropTypes.arrayOf(PropTypes.object),
};

AdditionalInformationSection.defaultProps = {
  customFields: []

};

const mapStateToProps = state => ({
  customFields: additionalInformationSelectors.selectCustomFields(state),
});

const mapDispatchToProps = dispatch => ({
  getCustomFields: (contactId) =>
    dispatch(additionalInformationActions.getCustomFields.action({ contactId })),
});

export default connect(mapStateToProps, mapDispatchToProps)(AdditionalInformationSection);
